import { APPID, APPVERSION } from "../common/globals";
import { BASE_AXIOS } from "../config";

export const apiCreateDeck = async (data) => {
    let form = new FormData();

    if (typeof data.deckName !== 'undefined' && data.deckName) {
        form.append("deckName", data.deckName);
    } else {
        return false;
    }

    form.append("mcid", data.mcid)
    form.append("key", data.key);
    form.append("deckPriority", data.deckPriority);
    form.append("ispublic", data.ispublic);
    form.append("isSpaced", data.isSpaced);
    form.append("isHome", data.isHome);
    form.append("isRandom", data.isRandom ? data.isRandom : 1);
    form.append("gameMode", data.gameMode);
    form.append("deckEnds", data.deckEnds ? 1 : 0);

    if (typeof data.flashCards !== 'undefined') {
        form.append("flashCards", data.flashCards);
    } else {
        form.append("flashCards", 0);
    }

    form.append('areas', data.areas ? data.areas : '');
    form.append('years', data.years ? data.years : '');
    

    let method = "createDeck";

    if (data.blankDeck) {
        form.append("blankDeck", data.blankDeck ? 1 : 0);
    }
    
    if (typeof data.deckSummary !== 'undefined' && data.deckSummary) {
        form.append("decksummary", data.deckSummary);
    } else {
        form.append("decksummary", '');
    }

    if (typeof data.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", data.tracking.pathname);
        form.append("pagevia", data.tracking.pagevia);
        form.append("action", data.tracking.action);
        form.append("os", data.tracking.os);
        form.append("ua", data.tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
    } 

    // console.log(`data: `, data);

    try {
        const results = await BASE_AXIOS().request({ 
            method: "POST",
            params: {
                method: method
            },
            data: form
        });

        let temp;
        if (typeof results.data[0].decks !== 'undefined') {
            temp = results.data[0].decks;
        } else { temp = []; }

        return temp;
    } catch (error) {
        throw error;
    }
};